export default "__VITE_ASSET__BtAVcu3B__"